import React from 'react';
import styled from 'styled-components';

const Youtube = styled.div`
    margin-top: ${(props) => props.device === "mobile" ? "100px" : "160px"};
    margin-bottom: ${(props) => props.device === "mobile" ? "80px" : "160px"};
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const YoutubeSection = ({device}) => {
    const deviceHeight = window.innerWidth*0.5625;

    return (
        <Youtube device={device}>
              <iframe 
              width={device === "mobile" ? "100%" : "1120"} 
              height={device === "mobile" ? deviceHeight : "630"}
              src="https://www.youtube.com/embed/dpndEhI5dhE?controls=0" 
              title="바른정플란트치과" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
              >
              </iframe>
        </Youtube>
    );
};

export default YoutubeSection;